import { render, staticRenderFns } from "./13.vue?vue&type=template&id=1f4bab34&scoped=true&"
import script from "./13.vue?vue&type=script&lang=js&"
export * from "./13.vue?vue&type=script&lang=js&"
import style0 from "./13.vue?vue&type=style&index=0&id=1f4bab34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4bab34",
  null
  
)

export default component.exports